import styles from './opportunityjourneywrapper.module.css';
import { OpportunityJourneySquare } from './OpportunityJourneySquare';
import OpportunityDetails from './OpportunityDetails';
import ReminderComponent from '../ReminderComponent'
import InteractionComponent from '../InteractionComponent'

const OpportunityJourneyContainerWrapper = ({oppData}) => {
    return(
        <div className={styles.wrapper}>
            <OpportunityJourneySquare  oppData = {oppData}/>
            <OpportunityDetails oppData = {oppData}/>
            <div className='flex flex-col md:flex-row md:justify-between w-full gap-4 md:gap-0 mr-0 md:mr-5 px-2 sm:px-0'>
                <ReminderComponent />
                <InteractionComponent />
            </div>
        </div>
    )
}
export default OpportunityJourneyContainerWrapper;